var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((3),function(n){return _c('v-skeleton-loader',{key:n,staticClass:"uploads-page-skeleton-loader mb-4",attrs:{"elevation":"2","type":"list-item-avatar","height":"64"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }